<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pid" @keyup="mtdlimpar_listagem()">
                            </div> 
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                       
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                        
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
									<option value="0">Em digitação</option>
									<option value="1">Aguardando</option>
                                    <option value="2">Entregue</option>
                                    <option value="3">Cancelado</option>
                                    <option value="4">Todas</option>
                                </select>
                            </div>                                                        
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-md-2" style="padding-top: 25px;">
                                <div class="custom-control custom-switch" style="width: 100%; position: absolute; left:">
                                    <input type="checkbox" class="custom-control-input" id="swresumoped" name="swresumoped" v-model="presumoped">
                                    <label class="custom-control-label" for="swresumoped">Resumo dos pedidos</label>
                                </div>						                                
                            </div>  
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstpedido"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.id, 8) }}
                                    </template>
                                    <template slot="slot_totalpedido" slot-scope="item">
                                        <strong style="color: #545b62;">{{ mtdformatavalordecimal(item.row.totalpedido, 2) }}</strong>
                                    </template>    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0"      class="badge badge-pill badge-primary bdg-digitacao" style="">Em digitação</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 1" class="badge badge-pill badge-primary bdg-aguardando">Aguardando</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 2" class="badge badge-pill badge-primary bdg-entregue">Entregue</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 3" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                    </template>                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-secondary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdimprimirpedidocompra(item.row.id)"><i class="fa fa-print"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpedido.length}}</span>
                                    </li>
                                    <!-- <div v-show="lstpedido.length > 0" >
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Em digitação
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info dgl">{{vqtddigitacao}}</span>
                                        </li>
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Aguardando
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info agl">{{vqtdaguardando}}</span>
                                        </li>
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Entregue
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info enl">{{vqtdentregue}}</span>
                                        </li>
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Cancelado
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info cal">{{vqtdcancelado}}</span>
                                        </li>
                                    </div>    -->
                                </ul>
                                <div v-show="presumoped" class="row justify-content-center" style="margin-top: 10px;">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <ul class="list-group">
                                            <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">RESUMO DOS PEDIDOS</a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Em digitação<strong style="padding-right: 60%;">({{vqtddigitacao}})</strong><span class="badge badge-secondary bgdigitacao">{{ mtdformatavalordecimal(vdigitacao) }}</span></a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Aguardando  <strong style="padding-right: 60%;">({{vqtdaguardando}})</strong><span class="badge badge-secondary bgaguardando"> {{ mtdformatavalordecimal(vaguardando) }}</span></a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Entregue    <strong style="padding-right: 60%;">({{vqtdentregue}})</strong><span class="badge badge-secondary bgentregue">{{ mtdformatavalordecimal(ventregue) }}</span></a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Cancelados  <strong style="padding-right: 60%;">({{vqtdcancelado}}) </strong><span class="badge badge-secondary bgcancelados">{{ mtdformatavalordecimal(vcancelado) }}</span></a>  
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-4 col-sm-4 col-md-6 col-lg-6" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                
                            </div> 
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdimprimirlistagem()"><i class="fa fa-print"></i> Imprimir</button>
                            </div> 
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Nr. Pedido:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
                            <div class="col-md-3">
                                <span class="lblselect2">*Fornecedor:</span>
                                <select id="cbfornecedor" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="vidfornecedor" v-bind:disabled="ativadesativa">
                                </select>
                            </div>                 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtentrega">*Dt. Entrega:</label>
								<div class="input-group">
									<date-picker id="eddtentrega" v-model="vdtentrega" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
                        </div>    
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens do pedido</a>
                                    </li>																			
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvitens" class="container-fluid tab-pane active">
                                        <div v-show="parseInt(this.opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-2">
                                                <label for="edidprodutoedicao">*Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-5">
                                                <label for="eddescricaoprodutoedicao">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold; text-transform: uppercase;" >
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-1">
                                                <label for="edundprodutoedicao">Und:</label>
                                                <input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edqtditemedicao">*Qtd:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <label for="edvlunitarioitemedicao">*Valor:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvlunitarioitemedicao" v-model="vvlunitarioedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align: right;"></money>
                                            </div>  
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <span class="lblselect2">*Marca:</span>
                                                <select id="cbmarca" data-placeholder="Selecione uma marca" v-model="vidmarca" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Grupo:</span>
                                                <select id="cbgrupo" data-placeholder="Selecione um grupo" v-model="vidgrupo" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="edtotalitemedicao">Total:</label>
                                                <money type="text" class="form-control form-control-sm" id="edtotalitemedicao" v-model="vtotalitemedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align: right;" disabled></money>
                                            </div>                                                                                      
										
                                            <div class="d-flex flex-row-reverse bd-highlight  col-sm-12 col-md-4 col-lg-4" style="padding-top: 22px;">
                                                <div class="d-flex flex-row-reverse bd-highlight col-sm-12 col-md-6 col-lg-6">
                                                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionaritem()" style="width: 100%;"><i class="fa fa-plus"></i> Incluir</button>
                                                </div>
                                            </div>   
                                                                                                                                
                                        </div>
                                        <div class="row">                                            
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table
                                                        :rows="lstitenspedido"
                                                        :columns="columnsitens"
                                                        :config="config"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                    
                                                    <template slot="slot_idproduto" slot-scope="item">
                                                        {{ item.row.idproduto }}
                                                    </template>
                                                    <template slot="slot_vlunitario" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vlunitario, 2) }}
                                                    </template>
                                                    <template slot="slot_totalitem" slot-scope="item">
                                                        <strong>{{ mtdformatavalordecimal(item.row.totalitem, 2) }}</strong>
                                                    </template>                                                                                                        
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritem(item.row)"><i class="fa fa-edit"></i></button>
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
                                            <div class="col-md-9">
                                            </div>
											<div class="col-md-3">
												<button v-show="parseInt(this.opcrud) < 3" type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdimportaritenscoletor()"><i class="fa fa-arrow-circle-o-down"></i> Importar itens do coletor</button>
											</div>                                                                                                                                       
                                        </div>
                                    </div>
                                    <div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>                                        
                                    </div>                                                                            
                                </div>                                                                    
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label for="edsolicitante">*Solicitante:</label>
                                <input type="text" class="form-control form-control-sm" id="edsolicitante" v-model="vsolicitante" maxlength="50" v-bind:disabled="ativadesativa">                                                
                            </div>                                            
                            <div class="col-md-4">
                                <label for="edcondicoespagamento">*Condições de pagamento:</label>
                                <input type="text" class="form-control form-control-sm" id="edcondicoespagamento" v-model="vcondicoespagamento" maxlength="100" v-bind:disabled="ativadesativa">                                                
                            </div>              
							<div class="col-md-2">
								<label for="cbimprimirvalores">Imprimir valores:</label>
								<select class="form-control form-control-sm" id="cbimprimirvalores" v-model="vimprimirvalores" v-bind:disabled="ativadesativa">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>                                          
							<div class="col-md-2">
								<label for="cbsituacao">Situação:</label>
								<select class="form-control form-control-sm" id="cbsituacao" v-model="vsituacao" v-bind:disabled="ativadesativa">
									<option value="0">Em digitação</option>
									<option value="1">Aguardando</option>
                                    <option value="2">Entregue</option>
                                    <option value="3">Cancelado</option>
								</select>
							</div>                                            
                        </div>
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        <strong style="color: #545b62;">Total do pedido</strong>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px!important;">{{ mtdformatavalordecimal(vtotalpedido, 2) }}</span>
                                    </li>
                                </ul>
                            </div>                            
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Alteração do item -->
        <div class="modal fade" id="mdealteraitem" tabindex="-1" role="dialog" aria-labelledby="mdalteraitem" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 14px;"><i class="fa fa-edit"></i> Alteração do item: {{ mtdformatarzeros(vitemalt.item, 3) }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="edqtditemalt">*Qtd.:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtditemalt" v-model="vqtditemalt" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                            </div>                              
                            <div class="col-md-12">
                                <label for="edvlunitarioitemalt">*Vl. Unitário:</label>
                                <money type="text" class="form-control form-control-sm" id="edvlunitarioitemalt" v-model="vvlunitarioalt" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                            </div>       
                            <div class="col-md-12">
                                <label for="edvltotalitemalt">Total do item:</label>
                                <money type="text" class="form-control form-control-sm" id="edvltotalitemalt" v-model="vtotalitemalt" v-bind="money" data-bv-group=".group" style="text-align: right;" disabled></money>
                            </div>
                            <div class="col-md-12">
                                <label for="cbmarcaalt">*Marca:</label>
                                <select id="cbmarcaalt" data-placeholder="Selecione uma marca" v-model="vidmarcaalt" data-allow-clear="true" data-bv-group=".group"  style="text-align: right;">
                                </select>
                            </div>       
                            <div class="col-md-12">
                                <label for="cbgrupoalt">*Grupo:</label>
                                <select id="cbgrupoalt" data-placeholder="Selecione um grupo" v-model="vidgrupoalt"  data-allow-clear="true" data-bv-group=".group"  style="text-align: right;">
                                </select>
                            </div>                                                                     
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-primary btn-sm" role="button" @click.prevent="mtdconfirmaralteracao()"><i class="fa fa-check"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadpedidoscompra',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variaveis da consulta de produtos
				vshowprtabela			: false,//oculta a visualização do preço do produto na listagem
				vidtabela				: 1,//informo somente pq o componente exige
                tipopropesquisa         : '',

                lstpedido  : [],
                pid          : '', 
                pidfilial    : null,     
                pidfornecedor: null,
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true),
                psituacao           : 4,                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vidfilial           : null,
                vidfornecedor       : null,
                vdtemissao			: util.DataAtual(),
                vdtentrega			: util.DataAtual(), 
                vcondicoespagamento     : '',               
                vobservacoes            : '',
                vsolicitante            : '',
                vtotalpedido            : 0,
                vimprimirvalores        : 0,
                vsituacao               : 0,    
                lstitenspedido          : [],
                presumoped              : false,

                //variaveis da permissao da vinculação vhabrelacaopedcompra
                vhabrelacaopedcompra    : false,

                //variaveis de edicao do item
                vitem                       : 0,
				vidprodutoedicao    		: '',
				vcoddigedicao				: '',
				vdescricaoprodutoedicao 	: '',
				vundprodutoedicao			: '',
				vqtditemedicao				: 1,
				vfracionadoedicao			: 0,
				vreferenciaedicao  		    : '',
                vvlunitarioedicao           : 0,
                vtotalitemedicao            : 0,
                
                vidgrupo                    : null,
                vidmarca                    : null,
                
                //variável para habilitação dos campos
                ativadesativa       : true,

                //variáveis da alteração do item
                vitemalt            : [],
                vqtditemalt         : 1,
                vvlunitarioalt      : 0,
                vtotalitemalt       : 0,
                vidgrupoalt         : null,
                vidmarcaalt         : null,
                //variaveis do resumo no rodapé
                vdigitacao          : 0,
                vaguardando         : 0,
                ventregue           : 0,
                vcancelado          : 0,

                vqtddigitacao       : 0,
                vqtdaguardando      : 0,
                vqtdentregue        : 0,
                vqtdcancelado       : 0,
		
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PEDIDOS DE COMPRA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-compra",
                        sort: false
                    },
                    {
                        label: "Nr. pedido",
                        name: "id",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fornecedor",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Entrega",
                        name: "dtentrega",
                        sort: true,
                        slot_name: "slot_dtentrega",
                        row_classes: "def-col-dtentrega",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total",
                        name: "totalpedido",
                        sort: true,
                        slot_name: "slot_totalpedido",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nf. for",
                        name: "idnotafor",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    }
                ],                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                columnsitens: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-item",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_idproduto",
                        row_classes: "def-col-idproduto",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Marca",
                        name: "descmarca",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Grupo",
                        name: "descgrupo",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Pr. Compra",
                        name: "vlunitario",
                        sort: true,
                        slot_name: "slot_vlunitario",
                        row_classes: "def-col-vlunitario",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total",
                        name: "totalitem",
                        sort: true,
                        slot_name: "slot_totalitem",
                        row_classes: "def-col-totalitem",                        
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }
                ]
            }
        },
        methods:{
			mtdformatavalordecimal(valor, digitos){
                if (parseFloat(valor) > 0){
				    return util.formatavalordecimais(valor, digitos);
                }else{
                    return 0;
                }
			},          
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtddefiniciais(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                
                $("#cbfornecedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesq").val();
                    vself.mtdlimpar_listagem();
                });

				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
				});

                $("#cbfornecedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfornecedor = $("#cbfornecedor").val();
                });

                $("#cbmarca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmarcas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidmarca = $("#cbmarca").val();
                }); 

                $("#cbgrupo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidgrupo = $("#cbgrupo").val();
                }); 

                $("#cbmarcaalt").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmarcas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidmarcaalt = $("#cbmarcaalt").val();
                }); 

                $("#cbgrupoalt").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidgrupoalt = $("#cbgrupoalt").val();
                }); 

				$('#mdealteraitem').on('shown.bs.modal', function (e) {
					$('#edqtditemalt').focus();
                });                               
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (this.pid !== ''){
                    rfiltro = ' and pc.id='+this.pid;
                }                                
                if (this.pidfilial !== null){
                    rfiltro = rfiltro +' and pc.idfilial='+this.pidfilial;
                }                
                if (this.pidfornecedor !== null){
                    rfiltro = rfiltro +' and pc.idfornecedor='+this.pidfornecedor;
                }
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and pc.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
				}                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregapedidos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregapedidos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    vself.lstpedido   = response.data.pedidoscompra;
                    vself.vdigitacao  = response.data.digitacao;
                    vself.vaguardando = response.data.aguardando;
                    vself.ventregue   = response.data.entregue;
                    vself.vcancelado  = response.data.cancelado;
                    
                    vself.vqtddigitacao  = response.data.qtddigitacao;
                    vself.vqtdaguardando = response.data.qtdaguardando;
                    vself.vqtdentregue   = response.data.qtdentregue;
                    vself.vqtdcancelado  = response.data.qtdcancelado;

                    loader.hide();
                }).catch(function (response) {
                    vself.lstpedido = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vitem                  = 0;
                this.vid                    = '';
                this.vidfilial              = null;
                this.vidfornecedor          = null;
                this.vdtemissao			    = util.DataAtual();
                this.vcondicoespagamento    = '';
                this.vobservacoes           = '';
                this.vsolicitante           = '';
                this.vtotalpedido           = 0;
                this.vimprimirvalores       = 0;
                this.vsituacao              = 0;
                this.lstitenspedido         = [];

                $("#cbfilial").val(null).trigger('change');
                $("#cbfornecedor").val(null).trigger('change');


                this.mtdlimparedicaoitem();

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {                        
                        $('#cbfilial').select2('open');
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 200);
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.005Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PEDIDO DE COMPRA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstpedido = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and pc.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.pedidoscompra[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#cbfilial').select2('open');
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('010Z.005Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if(item.idnotafor!=null){
                         this.$toastr.i('Não é possivel alterar um pedido que esteja vinculado a uma nota de fornecedor!', 'Informação!');
                         return
                    }
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE PEDIDO DE COMPRA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.005Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if(item.idnotafor!=null){
                         this.$toastr.i('Não é possivel alterar um pedido que esteja vinculado a uma nota de fornecedor!', 'Informação!');
                         return
                    }
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE PEDIDO DE COMPRA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vidfilial              = registro.idfilial;
                this.vidfornecedor          = registro.idfornecedor;
                this.vdtemissao			    = registro.dtemissao;
                this.vdtentrega			    = registro.dtentrega;
                this.vobservacoes           = registro.observacoes;
                this.vcondicoespagamento    = registro.condicoespagamento;               
                this.vsolicitante           = registro.solicitante;
                this.vtotalpedido           = parseFloat(registro.totalpedido);
                this.vimprimirvalores       = registro.imprimirvalores;
                this.vsituacao              = registro.situacao;
                this.lstitenspedido         = registro.itens;
                
                var deffilial  = new Option(registro.fantasiafilial, registro.idfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');
                
                var defforn  = new Option(registro.fantasia, registro.idfornecedor, true, true);
				$('#cbfornecedor').append(defforn).trigger('change');


                this.vitem                  = this.lstitenspedido[this.lstitenspedido.length - 1].item;
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'idfilial'          : this.vidfilial,
                    'idfornecedor'      : this.vidfornecedor,
                    'dtemissao'			: this.mtdformatadatagravar(this.vdtemissao),
                    'dtentrega'			: this.mtdformatadatagravar(this.vdtentrega),
                    'condicoespagamento': this.vcondicoespagamento,
                    'observacoes'       : this.vobservacoes,
                    'solicitante'       : this.vsolicitante,
                    'totalpedido'       : this.vtotalpedido,
                    'imprimirvalores'   : this.vimprimirvalores,
                    'situacao'          : this.vsituacao,
                    'itens'             : this.lstitenspedido
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.005Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.005Z.020Z' : '010Z.005Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo = 0;
                        vself.psituacao      = 4;
                        vself.pid            = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },			
			mtdlimparedicaoitem(){
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vfracionadoedicao			= 0;
				this.vreferenciaedicao  		= '';
                this.vvlunitarioedicao          = 0;
                this.vtotalitemedicao           = 0;     
                
                $("#cbmarca").val(null).trigger('change');
                $("#cbgrupo").val(null).trigger('change');
			},
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id;
							vself.vdescricaoprodutoedicao 	= produto.descricao;
							vself.vundprodutoedicao			= produto.und;
							vself.vfracionadoedicao			= produto.fracionado;
                            vself.vreferenciaedicao         = produto.referencia;
                            vself.vvlunitarioedicao         = produto.prcompra;

                            var defmarca  = new Option(produto.descmarca, produto.idmarca, true, true);
                            $('#cbmarca').append(defmarca).trigger('change');
                            
                            var defgrupo  = new Option(produto.descgrupo, produto.idgrupo, true, true);
                            $('#cbgrupo').append(defgrupo).trigger('change');

							vself.$nextTick(function () {
								$('#edqtditemedicao').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.mtdlimparedicaoitem();
				}
            },			
            mtdconsultarproduto(){
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdadicionaritem(){
				let vself = this;
				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}                
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
                if (parseFloat(this.vvlunitarioedicao) === 0){
                    this.$toastr.w('Informe um valor válido para o item!', 'Atenção!');
                    $('#edvlunitarioitemedicao').focus();
                    return;
				}
                if (this.vidmarca === null){
                    this.$toastr.w('Informe a marca na edição!', 'Atenção!');
                    return;
				}
                if (this.vidgrupo === null){
                    this.$toastr.w('Informe o grupo na edição!', 'Atenção!');
                    return;
				}                 
                if (util.findValInArray(this.lstitenspedido, 'idproduto', this.vidprodutoedicao)){                                
                    this.$toastr.w('Item já lançado no pedido!', 'Atenção!');
                    return;
                }
                vself.vitem++;
                let itemtmp = {
                    item			: vself.vitem,
                    idproduto		: vself.vidprodutoedicao,
                    idmarca         : vself.vidmarca,
                    descmarca       : $('#cbmarca').select2('data')[0]['text'],
                    idgrupo         : vself.vidgrupo,
                    descgrupo       : $('#cbgrupo').select2('data')[0]['text'],
                    descricao		: vself.vdescricaoprodutoedicao,
                    referencia      : vself.vreferenciaedicao,
                    coddig			: vself.vcoddigedicao,                    
                    qtditem			: vself.vqtditemedicao,
                    und			    : vself.vundprodutoedicao,
                    fracionado      : vself.vfracionadoedicao,
                    vlunitario      : vself.vvlunitarioedicao,
                    totalitem       : vself.vtotalitemedicao                    
                };         
                this.vtotalpedido = parseFloat(this.vtotalpedido) + parseFloat(this.vtotalitemedicao);
                vself.lstitenspedido.push(itemtmp);       
                vself.mtdlimparedicaoitem();
                setTimeout(() => {
                    $('#edidprodutoedicao').focus();
                }, 200);
            },
            mtdexcluiritem(item){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitenspedido, 'item', item.item);
                    this.vtotalpedido   = parseFloat(this.vtotalpedido) - parseFloat(this.lstitenspedido[indiceitem].totalitem);
                    this.lstitenspedido.splice(indiceitem, 1);                 
                }
            },
            mtdimportaritenscoletor(){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listarcoletor'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        let itenstmp = response.data.itenscoletor;
                        if (vself.lstitenspedido.length > 0){
                            vself.vitem  = vself.lstitenspedido[vself.lstitenspedido.length - 1].item;
                        }else{
                            vself.vitem  = 0;
                        }
                        for (let i = 0; i < itenstmp.length; i++) {
                            if (util.findValInArray(vself.lstitenspedido, 'idproduto', itenstmp[i].idproduto)){
                                let ii = util.getArrayIndexForKey(vself.lstitenspedido, 'idproduto', itenstmp[i].idproduto); 
                                vself.lstitenspedido[ii].qtditem   = parseFloat(vself.lstitenspedido[ii].qtditem) + parseFloat(itenstmp[i].qtd);
                                vself.lstitenspedido[ii].totalitem = parseFloat(vself.lstitenspedido[ii].totalitem) + (parseFloat(itenstmp[i].qtd) * parseFloat(itenstmp[i].prcompra));
                                vself.vtotalpedido = parseFloat(vself.vtotalpedido) + (parseFloat(itenstmp[i].qtd) * parseFloat(itenstmp[i].prcompra));
                            }else{  
                                vself.vitem++;
                                let itemtmp = {
                                    item			: vself.vitem,
                                    idproduto		: itenstmp[i].idproduto,
                                    descricao		: itenstmp[i].descricao,
                                    referencia      : itenstmp[i].referencia,
                                    idgrupo         : itenstmp[i].idgrupo,
                                    descgrupo       : itenstmp[i].descgrupo,
                                    idmarca         : itenstmp[i].idmarca,
                                    descmarca       : itenstmp[i].descmarca,
                                    coddig			: '',                    
                                    qtditem			: itenstmp[i].qtd,
                                    und			    : itenstmp[i].und,
                                    vlunitario      : itenstmp[i].prcompra,
                                    totalitem       : parseFloat(itenstmp[i].prcompra) * parseFloat(itenstmp[i].qtd)
                                };
                                vself.vtotalpedido = parseFloat(vself.vtotalpedido) + parseFloat(itemtmp.totalitem);
                                vself.lstitenspedido.push(itemtmp);                        
                            }
                        }                        
                    }
                }).catch(function (response) {
                    loader.hide();
                }); 
            },
            mtdcalculatotalitem(){
                this.vtotalitemedicao = parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao);
            },
			mtdimprimirpedidocompra(idpedido, tp){				
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedidocompra.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
            mtdalteraritem(item){
                this.vitemalt       = JSON.parse(JSON.stringify(item));                
                this.vqtditemalt    = this.vitemalt.qtditem;
                this.vvlunitarioalt = this.vitemalt.vlunitario;

                var defmarcaalt  = new Option(this.vitemalt.descmarca, this.vitemalt.idmarca, true, true);
				$('#cbmarcaalt').append(defmarcaalt).trigger('change');

                var defgrupoalt  = new Option(this.vitemalt.descgrupo, this.vitemalt.idgrupo, true, true);
				$('#cbgrupoalt').append(defgrupoalt).trigger('change');

                $('#mdealteraitem').modal('show');
            },
            mtdcalculatotalalt(){
                this.vtotalitemalt = parseFloat(this.vqtditemalt) * parseFloat(this.vvlunitarioalt);
            },
            mtdconfirmaralteracao(){
				if (parseFloat(this.vqtditemalt) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemalt').focus();
					return;
				} 
                if (parseInt(this.vitemalt.fracionado) === 0){
                    if (!Number.isInteger(this.vqtditemalt)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemalt').focus();
                        return;
                    }
				}                               
                if (parseFloat(this.vvlunitarioalt) === 0){
                    this.$toastr.w('Informe um valor válido para o item!', 'Atenção!');
                    $('#edvlunitarioitemalt').focus();
                    return;
				}
                if(this.vidmarcaalt===null){
                    this.$toastr.w('Informe a marca deste item!', 'Atenção!');
                    $('#cbmarcaalt').focus();
                    return;
                }   
                if(this.vidgrupoalt===null){
                    this.$toastr.w('Informe o grupo deste item!', 'Atenção!');
                    $('#cbgrupoalt').focus();
                    return;
                }   
                let inditem         = util.getArrayIndexForKey(this.lstitenspedido, 'idproduto', this.vitemalt.idproduto);             
                this.vtotalpedido   = parseFloat(this.vtotalpedido) - parseFloat(this.lstitenspedido[inditem].totalitem);

                this.lstitenspedido[inditem].qtditem    = parseFloat(this.vqtditemalt);
                this.lstitenspedido[inditem].vlunitario = parseFloat(this.vvlunitarioalt);
                this.lstitenspedido[inditem].totalitem  = parseFloat(this.vtotalitemalt);
                this.lstitenspedido[inditem].idmarca    = this.vidmarcaalt;
                this.lstitenspedido[inditem].idgrupo    = this.vidgrupoalt;
                this.lstitenspedido[inditem].descmarca  = $('#cbmarcaalt').select2('data')[0]['text'];
                this.lstitenspedido[inditem].descgrupo  = $('#cbgrupoalt').select2('data')[0]['text'];

                this.vtotalpedido   = parseFloat(this.vtotalpedido) + parseFloat(this.vtotalitemalt);

                this.vitemalt       = [];                
                this.vqtditemalt    = 1;
                this.vvlunitarioalt = 0;
                $('#mdealteraitem').modal('hide');                
            },
            mtdimprimirlistagem(){
                let vself   = this;              
                let filtro  = vself.mtdfiltropesquisa();
                let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let src     = vself.presumoped ? '1' : '0';
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidoscompra.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro+
                            '&dtini='+dtini+
                            '&dtfim='+dtfim+
                            '&rc='+src+
                            '&filial='+filial+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            }            
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('010Z.005Z', vself.$store.state.perfilusuario)) {
                        vself.vhabrelacaopedcompra   = util.opcaousuario('010Z.010Z.050Z', vself.$store.state.perfilusuario);
                        $('#pnlista').fadeIn(700);
                        vself.mtddefiniciais();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

             
            }
        },
        computed:{
            validou() {
                return this.vidfilial === null || this.vidfornecedor === '' || this.vdtemissao === null || this.vdtentrega === null ||
                this.vsolicitante === '' || this.vcondicoespagamento === '' || this.lstitenspedido.length === 0; 
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregapedidos(val);
            },			
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
            vqtditemedicao(){
                this.mtdcalculatotalitem(); 
            },
            vvlunitarioedicao(val){
               this.mtdcalculatotalitem(); 
            },
            vqtditemalt(){
                this.mtdcalculatotalalt(); 
            },
            vvlunitarioalt(val){
               this.mtdcalculatotalalt(); 
            },
        }
    }
</script>
<style>
    .def-col-cod{
        width: 100px !important;
    }
    .def-col-opcoes-compra{
        width: 150px !important;
    }
    .def-col-situacao{
        width: 90px !important;
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-aguardando{
        background: #EEA435!important;
        color: white;
    }
    .bdg-entregue{
        background: #5A956A!important;
    }
    .bdg-cancelado{
        background: #cc330d!important;
    }
    .bgdigitacao{
        background: #6BA2D0!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgaguardando{
        background: #EEA435!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgentregue{
        background: #5A956A!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgcancelados{
        background: #cc330d!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .dgl{
        background: #6BA2D0!important;
    }
    .agl{
        background: #EEA435!important;
    }
    .enl{
        background: #5A956A!important;
    }
    .cal{
        background: #cc330d!important;
    }
    
</style>